import * as t from "react";
import "./jsx-runtime.DGlMoOmv.js";
var r = t.createContext(void 0);
function n(o) {
  const e = t.useContext(r);
  return o || e || "ltr";
}
export {
  n as u
};
//# sourceMappingURL=index.BhJrV2wu.js.map
